import axios from 'axios'

export default class EmailService {


    async verifyEmail(token) {
        try {
            const res = await axios({
                method: 'get',
                url: process.env.VUE_APP_AUTH_URL + 'api/auth/verifyEmail?token=' + token,
                headers: {
                    authorization: token
                }
            });

            return res;

        } catch (error) {
            console.log('erroorr')
            throw new Error(error)
        }

        
    }


}